export default __webpack_public_path__ + "static/media/ava-05.53bccd00.png";